module.exports = __webpack_public_path__ + "img/10.0df128a2.jpg";